import { Button, FormLabel, Grid, MenuItem } from "@material-ui/core";
import { Formik } from "formik";
import React from "react";
import { date, object, string } from "yup";
import { getRangeTime } from "../../../../utils/getRangeTime";
import InputDatePicker from "../../../components/InputDatePicker";
import SelectDropOtions from "../../../components/SelectDropOtions";

export default function FormAppointment({ data, onSubmit, doctor }) {
    return (
        <Formik
            initialValues={{
                appointmentId: data?.appointmentId || 0,
                date: data?.appointDate || "",
                doctor: data?.doctor || "",
                time: data?.appointTime || "",
            }}
            validationSchema={object({
                date: date().required("Required."),
                time: string().required("Required."),
            })}
            onSubmit={onSubmit}>
            {({ values, errors, setFieldValue, handleSubmit }) => (
                <Grid container>
                    <Grid item xs={12} lg={6}>
                        <div className="d-flex justify-content-center align-items-center">
                            <InputDatePicker
                                variant="static"
                                value={values?.date}
                                onChange={date => {
                                    setFieldValue("date", date);
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        {data?.rights === "1" ? (
                            <div className="mb-4">
                                <FormLabel className="my-3">Select Doctor</FormLabel>
                                <SelectDropOtions
                                    value={values?.doctor}
                                    onChange={val => setFieldValue("doctor", val)}
                                    error={Boolean(errors?.doctor)}
                                    helperText={errors?.doctor}
                                    placeholder="Select Doctor"
                                    containerClass="border"
                                    options={doctor}
                                    renderOption={(option, idx) => (
                                        <MenuItem key={"doctor_a_s" + idx} value={option?.value}>
                                            {option?.title}
                                        </MenuItem>
                                    )}
                                />
                            </div>
                        ) : (
                            <Grid></Grid>
                        )}

                        <div>
                            <FormLabel className="my-3">
                                Add Time <span className="text-danger">*</span>
                            </FormLabel>
                            <SelectDropOtions
                                value={values?.time}
                                onChange={val => setFieldValue("time", val)}
                                error={Boolean(errors?.time)}
                                helperText={errors?.time}
                                placeholder="Select Time"
                                containerClass="border"
                                options={getRangeTime()}
                                renderOption={(option, idx) => (
                                    <MenuItem key={"time_asv" + idx} value={option?.value}>
                                        {option?.label}
                                    </MenuItem>
                                )}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} className="mt-4">
                        <div className="row justify-content-md-center">
                            <div className="col-6 col-md-4 col-lg-3 col-xl-4">
                                <Button onClick={handleSubmit} type="submit" className="w-100 btn t-btn-primary">
                                    Update Appointment
                                </Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
}
